var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ dark: _vm.darkMode },on:{"click":function($event){_vm.darkMode = !_vm.darkMode}}},[_vm._v(" Dark mode ")])}
var staticRenderFns = []

export { render, staticRenderFns }